namespace GeniuzPOS.Administration {
    export class PsSalesVatTypesColumns {
        static columnsKey = 'Administration.PsSalesVatTypes';
    }
}
